module.exports = __webpack_public_path__ + "static/img/anxunu03.cbfc1bcf.svg";